/** Keep campaign attribution but exclude contact details and lead/order identifiers. */
export function getAnalyticsPageUrl(href: string) {
  const url = new URL(href);
  const allowed = /^(utm_(source|medium|campaign|content|term)|yclid|gclid|branch|page)$/;
  for (const key of Array.from(url.searchParams.keys())) {
    if (!allowed.test(key)) url.searchParams.delete(key);
  }
  url.hash = '';
  return url.toString();
}

export function createPageViewTracker(initialHref: string) {
  let previousHref = getAnalyticsPageUrl(initialHref);
  return (href: string, send: (url: string, referer: string) => boolean) => {
    const currentHref = getAnalyticsPageUrl(href);
    // Metrica init owns the initial hit; StrictMode and rerenders must not duplicate it.
    if (currentHref === previousHref) return false;
    if (!send(currentHref, previousHref)) return false;
    previousHref = currentHref;
    return true;
  };
}
